import type { CloudEnvironmentCatalogRow } from "../../cmmd/cmmdForgeRuntimeListResource";
import type { CmmdForgeRuntimeLifecycleAction } from "../../environments/primary/cmmdForgeRuntimeApi";
import type { CloudEnvironmentLifecycleProjection } from "../../environments/primary/cloudEnvironmentLifecycleProjection";
import { ConnectionRowActionMenu } from "./ConnectionRowActionMenu";
import { getCloudRuntimeActions } from "./cloudRuntimeRowActions";

export interface CloudRuntimeRowActionHandlers {
  readonly onUpdate: (environment: CloudEnvironmentCatalogRow) => void;
  readonly onRunLifecycleAction: (
    environment: CloudEnvironmentCatalogRow,
    action: CmmdForgeRuntimeLifecycleAction,
  ) => void;
  readonly onRecoverEnvironment: () => void;
}

export function CloudRuntimeRowActionsCell({
  environment,
  lifecycle,
  isBusy,
  busyActionLabel,
  onDeleteEnvironment,
  handlers,
}: {
  readonly environment: CloudEnvironmentCatalogRow;
  readonly lifecycle: CloudEnvironmentLifecycleProjection;
  readonly isBusy: boolean;
  readonly busyActionLabel: string | null;
  readonly onDeleteEnvironment: () => void;
  readonly handlers: CloudRuntimeRowActionHandlers;
}) {
  const actions = getCloudRuntimeActions({
    maintenance: environment.maintenance,
    lifecycle,
  });
  return (
    <ConnectionRowActionMenu
      environment={environment}
      actions={actions}
      isBusy={isBusy}
      busyLabel={busyActionLabel}
      onUpdate={handlers.onUpdate}
      onDeleteEnvironment={onDeleteEnvironment}
      onRecoverEnvironment={handlers.onRecoverEnvironment}
      onRunLifecycleAction={handlers.onRunLifecycleAction}
    />
  );
}
